import { FetchClient, storeClient } from '@/shared/api/client';
import { BaselinkerOrderStatus } from './types';

export const fetchBaselinkerOrderStatus = async (
	email: string,
	baselinkerId: number,
	fetch?: FetchClient
): Promise<BaselinkerOrderStatus> => {
	try {
		const data = await storeClient<BaselinkerOrderStatus>(
			`/order/get-baselinker-order-page`,
			{
				method: 'POST',
				body: {
					email,
					baselinkerId,
				},
			},
			fetch
		);

		return data;
	} catch (e) {
		return {
			orderPage: null,
			status: '',
		};
	}
};
